import { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { useNoticeBannersStackActions } from '@sg/garnish';

export const useNotifyStripeCancel = () => {
  const { push: addNoticeBanner } = useNoticeBannersStackActions();
  const { formatMessage } = useIntl();
  const message = formatMessage(messages.message);

  return useCallback(
    (text = message) => {
      addNoticeBanner({ text, palette: 'neutral' });
    },
    [message, addNoticeBanner],
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  message: {
    defaultMessage: 'Order submission has been canceled.',
    description: 'Stripe Payment | Cancelation',
  },
});
